/**
 * Nom des types de mission, ex : Formation longue, soutient, etc
 */
export enum NotificationTypeEnum {
	SUIVI_TEMPS_TRAVAIL = 'Suivi de la consommation du temps de travail',
	SUIVI_DELAI_MISSION = 'Suivi des délais de la mission',
	FIN_MISSION = 'Fin de la mission',
	SUIVI_TRIMESTRIEL = 'Suivi trimestriel',
	CREATION_COMPTE = 'Création de compte',
	REINITIALISATION_MOT_DE_PASSE = 'Réinitialisation du mot de passe',
	SUIVI_BUDGET_TOTAL_BDC = 'Suivi du budget total BDC',
	SUIVI_BUDGET_PAR_LIGNE_BDC = 'Suivi du budget par ligne de BDC',
	SUIVI_BUDGET_PREVISIONNEL_TOTAL_BDC = 'Suivi du budget prévisionnel total sur un BDC',
	SUIVI_RAPPEL_RESTITUTION = 'Rappel restitution à faire'
}

export enum NotificationType {
	'SUIVI_TEMPS_TRAVAIL' = 'SUIVI_TEMPS_TRAVAIL',
	'SUIVI_DELAI_MISSION' = 'SUIVI_DELAI_MISSION',
	'FIN_MISSION' = 'FIN_MISSION',
	'SUIVI_TRIMESTRIEL' = 'SUIVI_TRIMESTRIEL',
	'CREATION_COMPTE' = 'CREATION_COMPTE',
	'REINITIALISATION_MOT_DE_PASSE' = 'REINITIALISATION_MOT_DE_PASSE',
	'SUIVI_BUDGET_TOTAL_BDC' = 'SUIVI_BUDGET_TOTAL_BDC',
	'SUIVI_BUDGET_PAR_LIGNE_BDC' = 'SUIVI_BUDGET_PAR_LIGNE_BDC',
	'SUIVI_BUDGET_PREVISIONNEL_TOTAL_BDC' = 'SUIVI_BUDGET_PREVISIONNEL_TOTAL_BDC',
	'SUIVI_RAPPEL_RESTITUTION' = 'SUIVI_RAPPEL_RESTITUTION'
}